export const GET_USER_GA_DATA_TIMEOUT = 300;
export const GET_USER_DATA_TIMEOUT = 300;
export const GET_EXPERIMENTS_TIMEOUT = 300;
export const GET_REGION_BY_DOMAIN_TIMEOUT = 100;
export const GET_REGIONS_TIMEOUT = 300;
export const GET_ADDRESS_TIMEOUT = 2500;
export const GET_BUILDER_NAME_TIMEOUT = 300;
export const GET_RAILWAY_LIST_TIMEOUT = 300;
export const GET_ROADS_TIMEOUT = 300;
export const GET_SEO_URLS_TIMEOUT = 9000;
export const GET_BUILDER_SUGGESTIONS_TIMEOUT = 9000;
